import React, { useRef, useState, useEffect } from 'react'
import { format, startOfDay, endOfDay, addDays, subDays, startOfWeek, isAfter, getDay } from 'date-fns'
import { useHistory } from 'react-router-dom'
import { orderBy } from 'lodash'
import FullCalendar from '@fullcalendar/react'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import ptLocale from '@fullcalendar/core/locales/pt'
import enLocale from '@fullcalendar/core/locales/en-nz'
import { alertDanger } from 'utils/toast'

import { translate } from 'locales'

// Context
import { useScheduleConfig } from 'context/schenduleConfig/schenduleConfig.context'

// Components
import { Header, Card, Loading, Footer } from 'components'
import * as Global from 'global/styles.global'
import OverlayConfig from './OverlayConfig'

// Styles
import * as S from './styles'

import { findScheduleConfiguration, handleDateClick } from './services'
import { IDoctorSchedule } from './interfaces'

import infoIcon from 'assets/icons/information-circle.svg'

const locales = window.localStorage.getItem('@StarBem:lang')

const generateHighDemandEvents = (startDate: Date, endDate: Date) => {
  const events: any[] = []
  let currentDate = startOfDay(startDate)
  const end = endOfDay(endDate)

  while (!isAfter(currentDate, end)) {
    const dayOfWeek = getDay(currentDate)
    const dateStr = format(currentDate, 'yyyy-MM-dd')

    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      events.push({
        start: `${dateStr}T08:00:00Z`,
        end: `${dateStr}T10:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T12:00:00Z`,
        end: `${dateStr}T14:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T18:00:00Z`,
        end: `${dateStr}T21:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
    } else if (dayOfWeek === 6) {
      events.push({
        start: `${dateStr}T08:00:00Z`,
        end: `${dateStr}T10:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T13:00:00Z`,
        end: `${dateStr}T14:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T15:00:00Z`,
        end: `${dateStr}T17:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T19:00:00Z`,
        end: `${dateStr}T20:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
    } else if (dayOfWeek === 0) {
      events.push({
        start: `${dateStr}T08:00:00Z`,
        end: `${dateStr}T09:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T15:00:00Z`,
        end: `${dateStr}T16:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
      events.push({
        start: `${dateStr}T20:00:00Z`,
        end: `${dateStr}T22:00:00Z`,
        display: 'background',
        backgroundColor: '#FCD4C3',
        classNames: ['high-demand-slot'],
        extendedProps: {
          isHighDemand: true,
        },
      })
    }

    currentDate = addDays(currentDate, 1)
  }

  return events
}

const ScheduleConfiguration = () => {

  const calendarRef = useRef<any>(null)
  const history = useHistory()

  const { doctorSchendule, setDoctorSchendule } = useScheduleConfig()

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [screenHeight, setScreenHeight] = useState(window.innerHeight)
  const [loading, setLoading] = useState<boolean>(true)
  const [newSchedule, setNewSchedule] = useState<IDoctorSchedule>({})
  const [occupations, setOccupations] = useState<any[]>([])
  const [selectedOccupation, setSelectedOccupation] = useState<any>({})
  const [country, setCountry] = useState<any[]>([])
  const [selectedCountry, setSelectedCountry] = useState<any>([])
  const [highDemandEvents, setHighDemandEvents] = useState<any[]>([])

  const allCountries = ['DE', 'ES', 'IE', 'IT', 'PT', 'US']

  const findData = () => {
    const userDataStorage = window.localStorage.getItem('@StarBem:user')
    const userDataFromStorage: any =
      userDataStorage && JSON.parse(userDataStorage)

    if (userDataFromStorage.specialties?.length === 0) {
      history.push('/perfil')
      return alertDanger(translate('schedule.needSpecialties'))
    }

    setOccupations(
      orderBy(
        userDataFromStorage.specialties.filter(
          (item: any) => item.status === 'active'
        ),
        ['asc']
      )
    )
    setSelectedOccupation(
      orderBy(
        userDataFromStorage.specialties.filter(
          (item: any) => item.status === 'active'
        ),
        ['asc']
      )[0]
    )

    setCountry(
      orderBy(userDataFromStorage.countries.filter((pais: any) => pais))
    )

    setSelectedCountry(allCountries)

    return true
  }

  const showModal = true

  useEffect(() => {
    findData()
    findScheduleConfiguration(setDoctorSchendule, setLoading)

    const handleSize = () => {
      setScreenWidth(window.innerWidth)
      setScreenHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleSize)

    const today = new Date()
    const currentDay = getDay(today)
    let weekStart: Date
    let weekEnd: Date

    if (currentDay === 0) {
      weekStart = startOfDay(subDays(today, 6))
      weekEnd = endOfDay(today)
    } else {
      weekStart = startOfDay(addDays(startOfWeek(today), 1))
      weekEnd = endOfDay(addDays(weekStart, 6))
    }

    const initialEvents = generateHighDemandEvents(weekStart, weekEnd)
    setHighDemandEvents(initialEvents)

    return () => {
      window.removeEventListener('resize', handleSize)
    }
  }, [])

  const interval =
    selectedOccupation.slug === 'clinico-geral'
      ? 60
      : selectedOccupation?.attendance_time || 30

  const handleOccupationSelecion = (e: any) => {
    const ocupation = occupations?.filter(
      (item: any) => item.id === e.target.value
    )[0]
    if (ocupation) {
      setSelectedOccupation(ocupation)
    }
    const intervalClick =
      ocupation.slug === 'clinico-geral' ? 60 : ocupation?.attendance_time || 30

    handleDateClick(
      { dateStr: newSchedule.start },
      setNewSchedule,
      intervalClick
    )
  }

  // const handleCountrySelection = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { id } = e.target

  //   if (selectedCountry.includes(id)) {
  //     setSelectedCountry(selectedCountry.filter((pais: any) => pais !== id))
  //   } else {
  //     setSelectedCountry([...selectedCountry, id])
  //   }
  // }

  return (
    <Global.Container>
      {loading && <Loading title={translate('schedule.loading')} />}
      <Header />
      <S.ContentConfig height={screenHeight}>
        <Card>
          <div className="header-config">
            <h1 className="title-config">
              {translate('schedule.configSchedule')}
            </h1>
            <button
              type="button"
              className="button-config"
              onClick={() => history.push('/abertura-horarios')}
            >
              Abertura de horários
            </button>
          </div>
          <div className="container-config">
            <div className="calendar-view">
              <S.HighDemandLabel>
                <S.DemandDot />
                {translate('schedule.highDemand')}
                <S.InfoIconWrapper>
                  <S.InfoIcon src={infoIcon} alt="Informação" />
                  <S.Tooltip>
                    {translate('schedule.highDemandTooltip')}
                  </S.Tooltip>
                </S.InfoIconWrapper>
              </S.HighDemandLabel>
              <S.InfoBanner>
                <S.InfoText>{translate('schedule.highDemandInfo')}</S.InfoText>
              </S.InfoBanner>
              <FullCalendar
                ref={calendarRef}
                plugins={[timeGridPlugin, interactionPlugin]}
                initialView={screenWidth > 768 ? 'timeGridWeek' : 'timeGridDay'}
                height="100%"
                contentHeight="100%"
                locale={locales === 'en' ? enLocale : ptLocale}
                slotDuration="00:15:00"
                slotLabelInterval="00:15:00"
                slotLabelFormat={{
                  hour: 'numeric',
                  minute: '2-digit',
                  omitZeroMinute: false,
                  meridiem: 'short',
                }}
                slotMinTime="08:00:00"
                slotMaxTime="24:00:00"
                dayHeaderFormat={{
                  weekday: 'long',
                  month: 'numeric',
                  day: 'numeric',
                }}
                timeZone="UTC"
                firstDay={1}
                events={[...doctorSchendule, newSchedule, ...highDemandEvents]}
                allDaySlot={false}
                datesSet={(arg) => {
                  const events = generateHighDemandEvents(arg.start, arg.end)
                  setHighDemandEvents(events)
                }}
                titleFormat={
                  screenWidth > 768
                    ? { day: 'numeric', month: 'long' }
                    : { day: 'numeric', month: 'numeric' }
                }
                eventOverlap
                eventResizableFromStart
                droppable={false}
                dateClick={(e) => {
                  handleDateClick(e, setNewSchedule, interval)
                }}
                eventContent={(info: any) => {
                  // Não renderiza conteúdo para eventos de alta procura (background events)
                  if (info.event.extendedProps?.isHighDemand) {
                    return null
                  }

                  return info.event && showModal ? (
                    <OverlayConfig
                      info={info}
                      occupations={occupations}
                      selectedOccupation={selectedOccupation}
                      setSelectedOccupation={setSelectedOccupation}
                      country={country}
                      selectedCountry={selectedCountry}
                      setSelectedCountry={setSelectedCountry}
                      handleOccupationSelection={handleOccupationSelecion}
                      newSchedule={newSchedule}
                      setNewSchedule={setNewSchedule}
                      doctorSchedule={doctorSchendule}
                      setDoctorSchedule={setDoctorSchendule}
                      setLoading={setLoading}
                    />
                  ) : (
                    <S.EventContent>
                      <p>
                        {info.event.extendedProps.status === 'confirmed'
                          ? info.event.extendedProps.occupation.name
                          : translate('schedule.notTitle')}
                      </p>
                    </S.EventContent>
                  )
                }}
              />
            </div>
          </div>
        </Card>
      </S.ContentConfig>
      <Footer />
    </Global.Container>
  )
}

export default ScheduleConfiguration
